import { render, staticRenderFns } from "./student-reply-refer-form.vue?vue&type=template&id=82634b1e&scoped=true&"
import script from "./student-reply-refer-form.vue?vue&type=script&lang=js&"
export * from "./student-reply-refer-form.vue?vue&type=script&lang=js&"
import style0 from "./student-reply-refer-form.vue?vue&type=style&index=0&id=82634b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82634b1e",
  null
  
)

export default component.exports